// import createTypes from "redux-create-action-types";

const types = {
  API_REQUEST: "API_REQUEST",
  API_SUCCESS: "API_SUCCESS",
  API_FAILURE: "API_FAILURE",
};


export default types;